import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ContactHero from "./components/ContactHero";
import LineConsult from "./components/LineConsult";
import ContactForm from "./components/ContactForm";
import FAQ from "./components/FAQ";
import ContactCTA from "./components/ContactCTA";

export default function ContactPage() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <ContactHero />
      <LineConsult />
      <ContactForm />
      <FAQ />
      <ContactCTA />
      <SiteFooter />
    </main>
  );
}
